import Overview from "@/components/admin/Content/WebPages/Resources/Publications/Overview";
import HeroSection from "@/components/admin/Content/WebPages/Resources/Publications/HeroSection";
import FullPageSpinner from "@/components/ui/FullPageSpinner";
import { useWebPageForm } from "@/contexts/WebPageFormContext";

const Publications = () => {
  const { pageData, isLoading } = useWebPageForm();

  if (isLoading) {
    return <FullPageSpinner />
  }

  return (
    <div className="flex flex-col gap-8 lg:gap-12 p-4 md:p-8 lg:p-12 xl:w-3/4 mx-auto">
      <HeroSection data={pageData?.PUBLICATION_BANNER ?? {
        sectionTag: 'PUBLICATION_BANNER',
        contentType: 'WITH_FILE',
        title: 'Publications Banner'
      }} />
      <Overview data={pageData?.PUBLICATION ?? {
        sectionTag: 'PUBLICATION',
        contentType: 'WITHOUT_FILE',
        title: 'Our Publications'
      }} />
    </div>
  )
}

export default Publications